import ROUTES from "./routes";

export const PUBLIC_PAGES = [ROUTES.AUTH.LOGIN()];

export const PERSISTENT_QUERY_PARAMS = [""];

// TIMEOUT CONSTANT
export const XUIID_TIMEOUT = 30; // days
export const XDEVICE_APP_TIMEOUT = 30; // days
export const ALERT_TIMEOUT = 6 * 1000; // seconds
export const SEARCH_TIMEOUT = 2 * 1000; // seconds
export const GEOLOCATION_TIMEOUT = 5 * 1000; // seconds
export const OTP_TIMEOUT = 5 * 60; // minutes

export const APP_PROPS = {
  name: "YPCR",
  description: "Youth Postpaid & Community Representative",
  // name: "YAE",
  // description: "Youth Account Executive",
};

export const APP_MEMBER_KEY = [
  "userAgent",
  "language",
  "timezone",
  "platform",
  "systemName",
  "hasLiedBrowser",
  "hasLiedOs",
  "deviceUuid",
  "ipAddress",
];

export const NETWORK_OBJECT_KEY = "ilovecoffee123!";
export const IS_DEV = process.env.NODE_ENV != "production";

export const LOCAL_DATA = {
  TASK: (id: string) => `crm.task.${id}`,
};
export const COOKIE = {
  DEVICE_UIID: "X-DEVICE-UIID",
  DEVICE_APPS: "X-FINGERPRINT-DATA",
  LOCALE: "NEXT_LOCALE",
};

export const MAIN_MENU = [
  {
    title: "Dashboard",
    icon: "fas fa-home",
    role: "*",
    link: "/",
  },
  {
    title: "Sales",
    icon: "fas fa-users",
    role: "YAE,Buddies,DS,Branch",
    // permission:
    //   "view account,view contact,view territory,view customer segmentation,view program,view product management,view opportunity,do task,view registration dealing",
    children: [
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-user",
        label: "Accounts",
        module: "Accounts",
        link: "/accounts",
        coming_soon: false,
        // permission: "view account,import account,edit account,delete account",
      },
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-phone",
        label: "Contacts",
        module: "Contacts",
        link: "/contacts",
        coming_soon: false,
        // permission: "view contact,import contact,edit contact,delete contact",
      },
      {
        role: "",
        icon: "fas fa-map-marker-alt",
        label: "Territories",
        module: "Territories",
        link: "/territories",
        coming_soon: true,
        // permission:
        //   "view territory,import territory,edit territory,delete territory",
      },
      {
        role: "",
        icon: "fas fa-address-card",
        label: "Program Management",
        module: "Program Management",
        link: "/program-management",
        coming_soon: true,
        // permission: "view program,import program,edit program,delete program",
      },
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-box-archive",
        label: "Products",
        module: "Products",
        link: "/products",
        coming_soon: false,
        // permission:
        //   "view product management,import product management,edit product management,delete product management",
      },
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-chart-line",
        label: "Opportunity",
        module: "Opportunity",
        link: "opportunities",
        coming_soon: false,
        // permission:
        //   "view opportunity,import opportunity,edit opportunity,delete opportunity",
      },
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-file-alt",
        label: "Registration Dealing",
        module: "Registration Dealing",
        link: "registration-dealing",
        coming_soon: false,
        // permission: "view registration dealing,import registration dealing",
      },
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-list-check",
        label: "Visit",
        module: "Visit",
        link: ROUTES.TASK.INDEX(),
        coming_soon: false,
        // permission: "do task",
      },
      {
        role: "Branch",
        icon: "fas fa-list-check",
        label: "History Visit YAE",
        module: "Log Visit",
        link: ROUTES.VISIT.INDEX(),
        coming_soon: false,
        // permission: "do task",
      },
    ],
  },
  {
    title: "Marketing",
    // permission: "send email",
    role: "",
    icon: "fas fa-envelope",
    children: [
      {
        icon: "fas fa-book",
        label: "Segmentasi Pelanggan",
        module: "Segmentasi Pelanggan",
        link: "/customer-segmentation-Area",
        role: "HQ,Super-Admin,Area,YAE",
        class: "pointer-events-none opacity-50",
        coming_soon: true,
      },
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-envelope-circle-check",
        label: "Email Marketing",
        module: "Email Marketing",
        link: "/email-management",
        coming_soon: true,
        // permission: "send email",
        children: [
          {
            label: "Template Email",
            module: "Template Email",
            link: "/email-management",
            role: "HQ,Super-Admin,Area",
          },
          {
            label: "Kirim Email",
            module: "Kirim Email",
            link: "/compose-email",
            role: "HQ,Super-Admin,Area",
          },
        ],
      },
    ],
  },
  {
    title: "Layanan",
    // permission: "view proposal,view event,view project,view asset management",
    role: "",
    icon: "fas fa-file",
    children: [
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-book",
        label: "Proposal",
        module: "Proposal",
        link: "/proposals",
        coming_soon: true,
        // permission: "view proposal,add proposal",
      },
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-calendar",
        label: "Event",
        module: "Event",
        link: "/events",
        coming_soon: true,
        // permission: "view event,import event,edit event,delete event",
      },
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-bars-progress",
        label: "Project",
        module: "Project",
        link: "/projects",
        coming_soon: true,
        // permission: "view project,import project,edit project,delete project",
      },
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-camera",
        label: "Asset Management",
        module: "Asset Management",
        link: "/asset-management",
        coming_soon: true,
        // permission:
        //   "view asset management,import asset management,edit asset management,delete asset management",
      },
    ],
  },
  {
    title: "Analitik",
    role: "",
    icon: "fas fa-chart-pie",
    // permission: "view performance",
    children: [
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-ranking-star",
        label: "Performance DigiPos",
        module: "Performance DigiPos",
        link: "/performances-digiposId",
        coming_soon: true,
        // permission: "view performance,import performance",
      },
      {
        icon: "fas fa-desktop",
        label: "Pulse",
        module: "Pulse",
        link: "/pulse-dashboard",
        role: "Super-Admin,YAE",
        coming_soon: true,
        // permission: "view users,import users",
      },
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-chart-bar",
        label: "Performance SkulId",
        module: "Performance SkulId",
        link: "/performances-skulId",
        coming_soon: true,
        // permission: "view performance skulId,import performance skulId",
      },
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-chart-bar",
        label: "Performance Nami",
        module: "Performance Nami",
        link: "/performances-nami",
        coming_soon: true,
        // permission: "view performance nami,import performance nami",
      },
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fa-solid fa-people-group",
        label: "Performance Buddies & DS",
        module: "Performance Buddies & DS",
        link: "/performances-buddies-ds",
        coming_soon: true,
        // permission: "view performance buddies ds",
      },
    ],
  },
  {
    title: "Pengaturan",
    role: "",
    icon: "fas fa-cog",
    permission:
      "view user,view role,view permission,view activity,view category,view type,view approval,view schedule,view buddies target",
    children: [
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-user",
        label: "Users",
        module: "Users",
        link: "/users",
        coming_soon: true,
        // permission: "view user,import user,edit user,delete user",
      },
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-cog",
        label: "Settings",
        module: "Settings",
        link: "/settings/general",
        coming_soon: true,
        // permission: "view schedule,view buddies target",
      },
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-university",
        label: "Faculties",
        module: "Faculties",
        link: "/faculties",
        coming_soon: true,
        // permission:
        //   "view faculty,import faculty,add faculty,edit faculty,delete faculty",
      },
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-users",
        label: "Roles",
        module: "Roles",
        link: "/roles",
        coming_soon: true,
        // permission: "view role,import role,edit role,delete role",
      },
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-check",
        label: "Approval",
        module: "Approval",
        link: "/approvals",
        coming_soon: true,
        // permission: "view approval",
      },
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-shield",
        label: "Permissions",
        module: "Permissions",
        link: "/permissions",
        coming_soon: true,
        // permission:
        //   "view permission,import permission,edit permission,delete permission",
      },
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-tasks",
        label: "User Activity",
        module: "User Activity",
        link: "/activities",
        coming_soon: true,
        // permission:
        //   "view activity,import activity,edit activity,delete activity",
      },
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-list",
        label: "Category Management",
        module: "Category Management",
        link: "/categories",
        coming_soon: true,
        // permission:
        //   "view category,import category,edit category,delete category",
      },
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fas fa-list",
        label: "Type Management",
        module: "Type Management",
        link: "/types",
        coming_soon: true,
        // permission: "view type,import type,edit type,delete type",
      },
      {
        role: "YAE,Buddies,DS,Branch",
        icon: "fa-solid fa-user-plus",
        label: "Register New DS",
        module: "Register New DS",
        link: "http://pendaftaran.youthcrm.id",
        copy: true,
        coming_soon: true,
        // permission: "view user",
      },
    ],
  },
];

export const REVALIDATE_TIME = 0;

export const EXPORT_TEMPLATE = {
  account_skullid: "/template/accounts-skulid-template.xlsx",
};

export const DATATABLE_STYLE = {
  headCells: {
    style: {
      backgroundColor: "#DAF7FF",
      color: "#00BCF1",
      fontSize: "0.6rem",
      fontWeight: "bolder",
    },
  },
  rows: {
    style: {
      fontSize: "0.6rem",
    },
  },
  cells: {
    style: {
      fontSize: "0.6rem", // font size for body cells
    },
  },
  pagination: {
    style: {
      fontSize: "0.6rem", // font size for pagination
    },
  },
  expanderCell: { style: { background: "#00BCF1", color: "white" } },
  expanderButton: {
    style: { color: "white" },
  },
};

export const FEATURE_FLAGS = {
  //PAGE
  yae_refresh_token: "yae_refresh_token",
};
